// Eager Stripe.js loader — kicks off the ~600KB stripe.js download as
// soon as the React app boots, NOT when the user lazy-navigates to
// /checkout. Without this, the Checkout.jsx chunk imports `loadStripe`
// only when its lazy chunk evaluates, so the user sees ~500-1500ms of
// "Preparing your secure checkout…" while Stripe.js downloads + warms
// up the iframe.
//
// Importing this module from a non-lazy entry point (App.js) starts the
// Stripe.js fetch concurrently with the rest of the app boot. By the
// time the merchant clicks Choose plan → /checkout, Stripe.js is
// already in the browser cache and Elements mount in <100ms.
//
// Safe to import multiple times: `loadStripe` internally memoises by
// publishable key.
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

// Single shared promise used by both Pricing prefetch and Checkout mount.
// Resolves to either a Stripe instance or null when the publishable key
// isn't configured (preview-only deployments).
export const stripePromise = STRIPE_PK ? loadStripe(STRIPE_PK) : null;

export const STRIPE_PUBLISHABLE_KEY = STRIPE_PK;
